module.exports = __webpack_public_path__ + "img/upload.66217f88.svg";